import { AnimatePresence } from 'motion/react'
import { useLaggedValue } from 'hooks/useLaggedValue'
import { type DiscountStepViewProps } from '../../discountProgressProps'
import {
  CHIP_CONTENT_TRANSITION,
  CHIP_ENTER_TRANSITION,
  CHIP_EXIT_TRANSITION,
  CHIP_SHIFT_TRANSITION,
  FILL_DURATION,
  INSTANT_TRANSITION,
  MARKER_TRANSITION,
} from './discountProgress.consts'
import * as S from './Marker.styles'

export function Marker({
  step,
  reached,
  reduceMotion,
  ref,
}: {
  step: DiscountStepViewProps
  reached: boolean
  reduceMotion: boolean
  ref?: React.Ref<HTMLDivElement>
}) {
  // The slide delay arms only during the fill's beat, so a mid-trip layout
  // restart (label swap resizing the chip) can't freeze the chip on a new delay.
  const laggedReached = useLaggedValue(
    reached,
    reduceMotion ? 0 : FILL_DURATION * 1000
  )
  const isFillBeatPlaying = reached !== laggedReached

  const transition = reduceMotion
    ? INSTANT_TRANSITION
    : {
        ...CHIP_ENTER_TRANSITION,
        layout: isFillBeatPlaying ? MARKER_TRANSITION : CHIP_SHIFT_TRANSITION,
      }

  return (
    <S.Chip
      $isIcon={step.goal === 'shipping'}
      ref={ref}
      layout="position"
      initial={reduceMotion ? false : { x: '100vw', opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      exit={{
        opacity: 0,
        transition: reduceMotion ? INSTANT_TRANSITION : CHIP_EXIT_TRANSITION,
      }}
      transition={transition}
      $reached={reached}
      data-testid={`discount-goal-${step.goal}`}
    >
      <AnimatePresence initial={false} mode="wait">
        <S.ChipContent
          key={step.goal === 'shipping' ? 'shipping' : step.badgeLabel}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={
            reduceMotion ? INSTANT_TRANSITION : CHIP_CONTENT_TRANSITION
          }
        >
          {step.goal === 'shipping' ? <S.ShippingBox /> : step.badgeLabel}
        </S.ChipContent>
      </AnimatePresence>
    </S.Chip>
  )
}
